import * as d3 from "d3";
import {
    colonAnnotation, contextMenu,
    createTooltip,
    DEFAULT_AXIS_FONT_SIZE,
    DEFAULT_AXIS_LABEL_FONT_SIZE,
    generateDownloadData,
    make_y_gridlines,
    numberFormat,
    pieChart,
    responsivefy
} from '../functions'

export default function (chart, divId, vizName, resData,filterParam, gridflag) {
    const defaultSize = true
    const defaultChartLayout = {
        width: 1200,
        height: 550,
        margin: { top: 30, right: 150, bottom: 100, left: 100 }
    }
    const chartWidth = defaultSize ? defaultChartLayout.width : chart.width
    const chartHeight = defaultSize ? defaultChartLayout.height : chart.height
    const chartMargin = defaultSize ? defaultChartLayout.margin : chart.margin

    var axisTickFontSize = (defaultSize ? DEFAULT_AXIS_FONT_SIZE : chart.axisFontSize) + "px"
    var axisTitleFontSize = (defaultSize ? DEFAULT_AXIS_LABEL_FONT_SIZE : chart.axisLabelFontSize) + "px"
    var fontColor = chart.axisFontColor
    var axisTitleColor = chart.axisLabelFontColor || fontColor
    //var tempVar = chart.tempVar
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    // axios.post(url, filterParam).then(res => {
        let data = resData

        //  var innerWidth = chart.width - chart.margin.left - chart.margin.right
        //  var innerHeight = chart.height - chart.margin.top - chart.margin.bottom
        d3.select(divId).selectAll("svg").remove();
        var groupData = d3.nest().key((d) => {
            return d.dim1_name
        }).entries(data)
        var subgroupNames = groupData[0].values.map(function (d) {
            return d.dim2_name;
        })
        var loadUnique = subgroupNames.filter(function (name, idx) {
            return subgroupNames.indexOf(name) === idx;
        })
        console.log("Group data values", data, groupData, subgroupNames)

        var svg = d3.select(divId)
            .append('svg')
            .attr("width", chartWidth + chartMargin.left + chartMargin.right)
            .attr("height", chartHeight + chartMargin.top + chartMargin.bottom)
            .call(responsivefy)
            .append("g")
            .attr("transform", "translate(" + chartMargin.left + "," + chartMargin.top + ")");

        var x1AxisLabel = d3.scaleBand().rangeRound([0, chartWidth]).paddingInner(.01)
        var x2AxisLabel = d3.scaleBand()
        var y1AxisLabel = d3.scaleLinear().rangeRound([chartHeight, 0])
        // var metric1ColorScale=d3.scaleLinear().domain([d3.min(load),d3.max(load)]).range(["#feb24c","#00441b"])
        var metric1ColorScale = d3.scaleOrdinal(pieChart);
        metric1ColorScale.domain(loadUnique)
        //Tooltips
        // should there be a class?
        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element
         var y1tip= tooltip_class()

         y1tip.attr('class', 'd3-tip'+divId.id)
              .html(d =>
                  chart.x1MetricTooltip+ colonAnnotation + numberFormat(d.metric1) + "<br/>" +
                  chart.y1MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                  chart.x2MetricTooltip + colonAnnotation + d.dim2_name)
         svg.call(y1tip)*/

        const tooltip = createTooltip(divId);

        x1AxisLabel.domain(groupData.map(function (d) {
            return d.key;
        }))
        x2AxisLabel.domain(loadUnique).rangeRound([0, x1AxisLabel.bandwidth()])
        y1AxisLabel.domain([0, d3.max(groupData, function (key) {
            return d3.max(key.values, function (d) {
                return d.metric1;
            });
        })]).nice()

        svg.append('g')
            .attr('class', 'axis-bottom')
            .attr('transform', 'translate(0,' + chartHeight + ')')
            .call(d3.axisBottom(x1AxisLabel))
            .selectAll("text")
            .style("font-size", axisTickFontSize)

        svg.append('text')
            .attr('x', (chartWidth /2))
            .attr('y', chartHeight + 60)
            .style('fill', axisTitleColor)
            .style("text-anchor","middle")
            .style('font-size', axisTitleFontSize)
            .text(chart.x1AxisDisplayName)

        svg.append("g")
            .attr("class", "y axis")
            .call(d3.axisLeft(y1AxisLabel).tickFormat(numberFormat))
            .style("font-size", axisTickFontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chartMargin.left + 10)
            .attr('x', 0 - (chartHeight / 2))
            .attr("dy", ".71em")
            .style("text-anchor", "middle")
            .style('fill', axisTitleColor)
            .style('font-size', axisTitleFontSize)
            .text(chart.y1AxisDisplayName)

        if (gridflag == true) {
            // add the X gridlines
            /*  svg.append("g")
                  .attr("class", "grid")
                  .attr("transform", "translate(0," + chart.height + ")")
                  .call(make_x_gridlines(x1Scale)
                      .tickSize(-chart.height)
                      .tickFormat("") )*/

            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(make_y_gridlines(y1AxisLabel)
                    .tickSize(-chartWidth)
                    .tickFormat(""))
        }
        var slice = svg.selectAll(".slice")
            .data(groupData)
            .enter()
            .append("g")
            .attr("class", "g")
            .attr('transform', d => 'translate(' + x1AxisLabel(d.key) + ',0)')

        slice.selectAll('rect')
            .data(function (d) {
                return d.values;
            })
            .enter()
            .append('rect')
            .attr('x', d => x2AxisLabel(d.dim2_name))
            .attr('y', y1AxisLabel(0))
            .attr('width', x2AxisLabel.bandwidth())
            .attr('height', chartHeight - y1AxisLabel(0))
            .attr('fill', d => metric1ColorScale(d.dim2_name))
            .on("mouseover", function(d) {
                console.log(d3.event, d); // For debugging, log the event and data
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return chart.x1MetricTooltip + colonAnnotation + numberFormat(d.metric1) + "<br/>" +
                        chart.y1MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                        chart.x2MetricTooltip + colonAnnotation + d.dim2_name
                });
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on("mouseout", function() {
                // Hide the tooltip on mouse out
                tooltip.onMouseLeave();
            })
            .on('contextmenu', function(d) {

                // Prepare clickedData with both axes' info
                const clickedData = {
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name],  // e.g., "2019", "2020"
                    [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]: [d.dim2_name]               // e.g., "metric1"
                };
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                d3.event.preventDefault();
            });

        slice.selectAll("rect")
            .transition()
            .delay(function () {
                return Math.random() * 1000;
            })
            .duration(1000)
            .attr("y", function (d) {
                return y1AxisLabel(d.metric1);
            })
            .attr("height", function (d) {
                return chartHeight - y1AxisLabel(d.metric1);
            });

        var legendRows = svg.selectAll("g.legend")
            .data(loadUnique, function (d) {
                return String(d);
            });
        legendRows.exit().remove();
        var legendEnter = legendRows.enter().append("g")
            .attr("class", "legend")
            .attr("text-anchor", "end");
        legendEnter.append("rect")
            .attr("x", chartWidth + 20)
            .attr("width", 10)
            .attr("height", 10)
            .attr("fill", metric1ColorScale);
        legendEnter.append("text")
            .attr("class", "legend-label")
            .attr("x", chartWidth + 60)
            .attr("y", 6)
            .attr("dy", "0.32em")
            .style("font-size", axisTickFontSize)
            .style("fill", fontColor)
            .text(function (d) {
                var s = String(d);
                return s.charAt(0).toUpperCase() + s.slice(1).replace(/([A-Z])/g, "$1");
            });
        legendEnter.merge(legendRows)
            .attr("transform", function (d, i) {
                return "translate(0," + i * 20 + ")";
            });
    // })
}
